import React, { Component } from 'react';
import webSocketClient from '../socket/socket';
import { FaSignInAlt } from 'react-icons/fa';

// import fotoUser from "../img/callcenter.png";
import fotoUser from "../img/logosm.png"

import { 
    HeaderTitle,
    LogoContainer, 
    LogoImage, 
    PageLogin, TitleContainer, WidgetBody, WidgetContainer, WidgetFooter, WidgetHeader, WidgetMain,
    FooterText, LoginMessage
} from '../component/Component.Login';
import {
    RowInput,
    InputLabel,
    InputText,
    RowButton,
    Button, ButtonIcon, ButtonLabel
 } from '../component/InputComponent';

class WidgetLogin extends Component {
    constructor(props){
        super(props);

        this.hostname                   = this.props.hostname;
        this.port                       = this.props.port;
        this.funcUpdateLoggedIn         = this.props.funcUpdateLoggedIn;

        this.state = {
            username: '',
            password: '',
            inputMessage: '',
        }        
        this.profilePics                = fotoUser;
        this.socketClient               = webSocketClient();

        this.handleInputChange          = this.handleInputChange.bind(this);
        this.handleLoginSubmit          = this.handleLoginSubmit.bind(this);

        this.funcUpdateAccess           = this.props.funcUpdateAccess;
        this.funcUpdateMenu             = this.props.funcUpdatePage;
    }

    componentDidMount(){
        if (document.getElementById('login-username') !== null){
            document.getElementById('login-username').focus()
        }
    }

    handleInputChange(event){
        event.preventDefault();
        let tmpFieldName    = event.target.name;
        let tmpFieldValue   = event.target.value;

        if (event.target.validity.valid){
            this.setState({[tmpFieldName]: tmpFieldValue});
        }        
    }

    handleLoginSubmit(event){
        event.preventDefault();
        if (this.state.username.trim() === '' && this.state.password.trim() === ''){
            this.setState({
                ...this.state,
                inputMessage: 'Please enter your username !',
            }); 
            if (document.getElementById('login-username') !== null){
                document.getElementById('login-username').focus()
            }       
        } else if (this.state.username.trim() === '' && this.state.password.trim() !== ''){
            this.setState({
                ...this.state,
                inputMessage: 'Please enter your username !',
            });
            if (document.getElementById('login-username') !== null){
                document.getElementById('login-username').focus()
            }
        } else if (this.state.username.trim() !== '' && this.state.password.trim() === ''){
            this.setState({
                ...this.state,
                inputMessage: 'Please enter your password !',
            });
            if (document.getElementById('login-password') !== null){
                document.getElementById('login-password').focus()
            }
        } else {
            if (this.props.socketConnected) {
                this.socketClient.sendAction({
                    action: 'Login',
                    username: this.state.username,
                    password: this.state.password,
                }, (response) => {
                    if (!response.success){
                        this.setState({
                            ...this.state,
                            inputMessage: response.message,
                        });
                        this.funcUpdateLoggedIn({
                            isConnected: true,
                            isLoggedIn: false,
                            hostname: this.hostname,
                            port: this.port,
                        });
                    } else {
                        this.funcUpdateLoggedIn({
                            isConnected: true,
                            isLoggedIn: true,
                            hostname: this.hostname,
                            port: this.port,
                        });
                        if (response.hasOwnProperty("ReturningAccess") && response.ReturningAccess instanceof Array) {
                            if (typeof this.funcUpdateAccess === 'function') {
                                this.funcUpdateAccess(response.ReturningAccess);
                            }
                        }
    
                        if (response.hasOwnProperty("ReturningMenu") && response.ReturningMenu instanceof Array) {
                            if (typeof this.funcUpdateMenu === 'function') {
                                this.funcUpdateMenu(response.ReturningMenu);
                            }
                        }
                    }
                });
            } else {
                this.socketClient.connectToHost(this.hostname, this.port, (e) => {
                    if (e.type === 'open') {
                        this.socketClient.sendAction({
                            action: 'Login',
                            username: this.state.username,
                            password: this.state.password,
                        }, (response) => {
                            if (!response.success){
                                this.setState({
                                    ...this.state,
                                    inputMessage: response.message,
                                });
                                this.funcUpdateLoggedIn({
                                    isConnected: true,
                                    isLoggedIn: false,
                                    hostname: this.hostname,
                                    port: this.port,
                                });
                            } else {
                                this.funcUpdateLoggedIn({
                                    isConnected: true,
                                    isLoggedIn: true,
                                    hostname: this.hostname,
                                    port: this.port,
                                });
                                if (response.hasOwnProperty("ReturningAccess") && response.ReturningAccess instanceof Array) {
                                    if (typeof this.funcUpdateAccess === 'function') {
                                        this.funcUpdateAccess(response.ReturningAccess);
                                    }
                                }
            
                                if (response.hasOwnProperty("ReturningMenu") && response.ReturningMenu instanceof Array) {
                                    if (typeof this.funcUpdateMenu === 'function') {
                                        this.funcUpdateMenu(response.ReturningMenu);
                                    }
                                }
                            }
                        });
                    } else {
                        this.funcUpdateLoggedIn({
                            isConnected: false,
                            isLoggedIn: false,
                            hostname: this.hostname,
                            port: this.port,
                        });

                        this.setState({
                            ...this.state,
                            inputMessage: `Cannot connect to ${this.hostname} port ${this.port}`,
                        });  
                    }
                });
            }
        }
    }

    render() {
        return (
            <PageLogin>
                <WidgetContainer>
                    <WidgetMain>
                        <WidgetHeader>
                            <LogoContainer><LogoImage src={this.profilePics} /></LogoContainer>
                            <TitleContainer><HeaderTitle>Robocall Manager</HeaderTitle></TitleContainer>
                        </WidgetHeader>
                        <WidgetBody>
                            <form onSubmit={(e) => {this.handleLoginSubmit(e);}}>
                                <RowInput IsMultiRow={true} Width={100}>
                                    <InputLabel FontSize={'12px'} Color={'#002b70'}>Username</InputLabel>
                                    <InputText FontSize={'12px'} name="username" id="login-username" pattern="[A-Za-z0-9.]+" value={this.state.username} onChange={(e) => {this.handleInputChange(e);}} />
                                </RowInput>
                                <RowInput MarginTop={3} IsMultiRow={true} Width={100}>
                                    <InputLabel FontSize={'12px'} Color={'#002b70'}>Password</InputLabel>
                                    <InputText FontSize={'12px'} IsPassword={true} name="password" id="login-password" pattern="[A-Za-z0-9.]+" value={this.state.password} onChange={(e) => {this.handleInputChange(e);}} />
                                </RowInput>
                                <RowButton MarginTop={20} Align={'right'}> 
                                    <Button IsSubmitButton Mode={'primary'} Height={30} Width={90} BackLightOnHover>
                                        <ButtonLabel IsUpperCase={true} FontSize={'0.9em'} IsBold={true}>Login</ButtonLabel>&ensp;
                                        <ButtonIcon><FaSignInAlt size={15}/></ButtonIcon>
                                    </Button>
                                </RowButton>
                            </form>
                        </WidgetBody>
                        <WidgetFooter MarginTop={10}>
                            <LoginMessage>{this.state.inputMessage}</LoginMessage>
                            <FooterText>&copy; Copyright 2025, PT. Aplikasi Yelow Olahkata</FooterText>
                        </WidgetFooter>
                    </WidgetMain>
                </WidgetContainer>
            </PageLogin>
        )
    }
}

export default WidgetLogin;